import React, { useEffect,useState } from 'react'
import Tab from '@mui/material/Tab';
import Box from "@mui/material/Box";
import Grid from '@mui/material/Grid';
import TabList from '@mui/lab/TabList';
import { Button } from '@mui/material';
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import FormEditToolTip from '../components/FormEditToolTip';
import { Link, useParams } from 'react-router-dom';
import { getFilesLoading, getSingleTooltipData} from "../selector/selectors";
import { editTooltipData,editEventTooltip, deleteEventToolTip} from "../api/tooltipsapi";
import swal from 'sweetalert';
import { connect } from 'react-redux';
import LoaderComponent from '../components/LoaderComponent';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const EventToolTipEdit = ({
    isLoading,
    toolTipData,
    editEventTooltip,
    editTooltipData
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams();
    const [value, setValue] = React.useState('1');
    const [content, setContent] = useState('');
    const handleChange = (event, newValue) =>{
        setValue(newValue);
    };
    const [editTooltipInfo, setEditTooltipInfo] = React.useState({
        id : '',
        event_id : '',
        event_name: '',
    });
    
    
    useEffect(() => {
        editTooltipData(params.id);
    }, [editTooltipData,params.id]);

    
    useEffect(() => {
        setEditTooltipInfo({
          event_id : toolTipData?.event_id ? toolTipData?.event_id : '',
          event_name: toolTipData?.event_name ? toolTipData?.event_name : '',
          id : toolTipData?.id ? toolTipData?.id : '',
          description : toolTipData?.description ? JSON.parse(toolTipData?.description) : ''
        });
    },[toolTipData]);


    const handleEditFormData = () => {
        let contentLength = '0';
        let contentToStore = '';
        if(typeof content?.blocks?.length === "undefined" && editTooltipInfo?.description?.blocks?.length > 0){
            contentLength = 1;
            contentToStore = JSON.stringify(editTooltipInfo?.description);
        } else {
            contentLength = content?.blocks?.length;
            contentToStore = JSON.stringify(content);
        }
        const formData = new FormData(); 
        if(editTooltipInfo.length === 0 || editTooltipInfo.event_id === '' || editTooltipInfo.event_name === '' || contentLength <= 0){
          swal("Oops!", "Please fill required fields!", "error");
          return;
        }
        Object.keys(editTooltipInfo).forEach(key =>   formData.append(key, key !== 'description' ? editTooltipInfo[key] : contentToStore) );
        editEventTooltip(formData);
        swal({
            title: "Success",
            text: "Tooltip updated successfully.",
            icon: "success",
            closeOnClickOutside:false,
            closeOnEsc: false,
            allowOutsideClick: false,
          })
          .then(marked => {
            if (marked) {
                navigate('/web/tooltips');
            }
        });
    }

    const handleDeleteTooltip = (e,rowId) => {
        e.preventDefault();
        swal({
            title: "Are you sure?",
            text: "Are you sure you want to Delete Event Tooltip!",
            icon: "warning",
           buttons: ["Cancel", "OK"],
          })
          .then(willDelete => {
            if (willDelete) {
                dispatch(deleteEventToolTip(rowId));
                swal({
                    title: "Success",
                    text: 'Tooltip Deleted Successfully.',
                    icon: "success",
                    closeOnClickOutside:false,
                    closeOnEsc: false,
                    allowOutsideClick: false,
                  })
                  .then(marked => {
                    if (marked) {
                        navigate('/web/tooltips');
                    }
                });
            }
          });
    };

    return (
        <Box sx={{ flexGrow: 1 }} >
            { isLoading ?  <LoaderComponent />: <></>}
            <Grid container >
                <TabContext value={value}>
                    <Grid item xs={12} md={12} lg={12} >
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={handleChange} aria-label="">
                            <Tab label="Edit Event ToolTip" value="1" />
                        </TabList>
                        </Box>
                        <TabPanel value="1" sx={{p:0,pt:2}}>
                            
                            <Grid container className="buttonJustifyLeft" sx={{paddingBottom:1, display: 'flex'}}>
                                <Grid className="buttonSpacing buttonMarginRight">
                                    <Button 
                                        variant="contained"
                                        size="medium"
                                        color="primary"
                                        onClick={handleEditFormData}
                                    >
                                        <EditIcon fontSize="medium"  sx={{paddingRight:1}} /> Update
                                    </Button> 
                                </Grid>
                                <Grid className="buttonSpacing buttonMarginRight">
                                    <Button 
                                        variant="contained"
                                        size="medium"
                                        color="error"
                                        onClick={(e)=>handleDeleteTooltip(e,toolTipData?.id)}
                                    >
                                        <DeleteIcon fontSize="medium"  sx={{paddingRight:1}} /> Delete
                                    </Button> 
                                </Grid>
                                <Grid className="buttonSpacing">
                                    <Button 
                                        variant="contained"
                                        size="medium"
                                        color="secondary"
                                        component={Link} to="/web/tooltips"
                                    >
                                    Cancel
                                    </Button> 
                                </Grid>
                            </Grid>
                            <FormEditToolTip 
                                content={content}
                                setContent={setContent}
                                setEditTooltipInfo={setEditTooltipInfo}
                                editTooltipInfo={editTooltipInfo}
                            />
                        </TabPanel>
                    </Grid>
                </TabContext>   
            </Grid>
        </Box>
    )
}

const mapStateToProps = (state) => ({
    isLoading: getFilesLoading(state),  
    toolTipData:getSingleTooltipData(state)
});
const mapDispatchToProps = (dispatch) => ({
    editTooltipData:(id)        => dispatch(editTooltipData(id)),
    editEventTooltip: (data)    => dispatch(editEventTooltip(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EventToolTipEdit); 
